
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/returns",
      function () {
        return require("private-next-pages/india/returns.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/returns"])
      });
    }
  